<script setup>
import { ref, computed } from "vue";
import axios from "axios";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

const store = useStore();
const { t } = useI18n();

const isLoading = ref(false);
const isOpen = computed(() => !store.state.auth.user.hasTermsAccepted);

const termsCheckbox = ref(false);
const marketingCheckbox = ref(false);

const buttonDisabled = computed(() => !termsCheckbox.value);

const updateTermsAcceptanceOnServer = async () => {
  try {
    await axios.post("api/user/accept-consents", {
      terms_consent: termsCheckbox.value,
      marketing_consent: marketingCheckbox.value,
    });
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const setTermsAcceptance = async () => {
  isLoading.value = true;

  const success = await updateTermsAcceptanceOnServer();
  success && store.commit("auth/setTermsAcceptance");

  isLoading.value = false;
};
</script>

<template v-if="!!store.state.auth.user">
  <v-dialog class="element-above-user_guiding" v-model="isOpen" persistent max-width="500">
    <v-card>
      <v-card-title class="dialog-title">
        {{ t("term_popup.title") }}
        <div class="dialog-subtitle">{{ t("term_popup.subtitle") }}</div>
      </v-card-title>

      <!-- NOTE: This is a hack to make the checkbox work in the user guiding. Do not remove ug-exit-preview-helper-container class -->
      <v-card-text class="dialog-content ug-exit-preview-helper-container">
        <!-- CHECKBOX TERMS -->
        <v-checkbox class="checkbox" label="Checkbox" v-model="termsCheckbox">
          <template v-slot:label>
            <p
              class="checkbox-label"
              v-html="
                t('term_popup.description.full', {
                  terms: t('term_popup.terms_and_conditions.title'),
                  termsLink: t('term_popup.terms_and_conditions.link'),
                  privacy: t('term_popup.privacy_policy.title'),
                  privacyLink: t('term_popup.privacy_policy.link'),
                })
              "
            ></p>
          </template>
        </v-checkbox>

        <!-- CHECKBOX MARKETING -->
        <v-checkbox class="checkbox" label="Checkbox" v-model="marketingCheckbox">
          <template v-slot:label>
            <p class="checkbox-label">{{ t("marketing_consent") }}</p>
          </template>
        </v-checkbox>

        <v-btn
          class="mt-4"
          color="primary"
          :text="t('term_popup.button')"
          variant="flat"
          @click="setTermsAcceptance"
          :loading="isLoading"
          :disabled="buttonDisabled"
        ></v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
.dialog-title {
  font-size: 1.4rem;
  font-weight: bold;
  padding: 20px 20px 10px;
  text-align: center;
}

.dialog-subtitle {
  font-size: 0.95rem;
  font-weight: normal;
  margin-top: 8px;
  color: #6b6b6b;
}

.dialog-content {
  color: #858788;
  text-align: center;
  padding: 15px 24px 20px;
}

.checkbox {
  margin-bottom: 8px;
  
  :deep(.v-input__details) {
    min-height: 14px;
    padding-top: 2px;
  }
}

.checkbox-label {
  text-align: left;
  font-size: 0.9rem;
  line-height: 1.3;
}

.close-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  margin-right: 20px;

  img {
    cursor: pointer;
  }
}
</style>
